import { inject } from '@angular/core';

import { translate } from '@jsverse/transloco';
import { ColDef } from 'ag-grid-community';

import {
  MaterialNumberPipe,
  ScrambleMaterialNumberPipe,
} from '@cdba/shared/pipes';

import { ColumnUtilsService } from '../../table';

export class CommonColumnDefinitionService {
  readonly columnUtilsService = inject(ColumnUtilsService);

  readonly materialNumberPipe = inject(MaterialNumberPipe);
  readonly scrambleMaterialNumberPipe = inject(ScrambleMaterialNumberPipe);

  AUTO_GROUP_COLUMN_DEF: ColDef = {
    headerName: translate('shared.bom.headers.materialDesignation'),
    resizable: true,
    lockPosition: true,
    lockVisible: true,
    minWidth: 300,
    cellRendererParams: {
      suppressCount: true,
      innerRenderer: 'bomMaterialDesignationCellRenderComponent',
      suppressDoubleClickExpand: true,
    },
  };
}
